// Keep the slot's reservationDayId with its time. A date can have several
// independent time spans, so reservedTimes[0] must never identify a selection.
const minutesOfDay = (value) => {
  const [hours, minutes] = String(value || '').split(':').map(Number);
  if (!Number.isInteger(hours) || !Number.isInteger(minutes) || hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return null;
  return hours * 60 + minutes;
};

const formatMinutes = (minutes) => {
  const dayMinute = ((minutes % 1440) + 1440) % 1440;
  return `${String(Math.floor(dayMinute / 60)).padStart(2, '0')}:${String(dayMinute % 60).padStart(2, '0')}`;
};

export const reservationSlotKey = (slot) => `${slot.reservationDayId}|${slot.time}`;

export const buildReservationSlots = (timeSpans = []) => {
  const slots = [];
  (Array.isArray(timeSpans) ? timeSpans : []).forEach((span) => {
    const start = minutesOfDay(span.startTime);
    const end = minutesOfDay(span.endTime);
    const count = Number(span.patientNumber);
    if (start == null || end == null || !Number.isInteger(count) || count <= 0 || !span.reservationDayId) return;
    const duration = (end < start ? end + 1440 : end) - start;
    const interval = Math.floor(duration / count);
    // A zero-minute interval would create identical, unbookable choices.
    if (interval <= 0) return;
    for (let i = 0; i < count; i += 1) {
      const slot = {
        reservationDayId: span.reservationDayId,
        reservationDate: span.reservationDate,
        requestGroupId: span.requestGroupId,
        subRequestGroupId: span.subRequestGroupId,
        endReservationTime: span.endReservationTime,
        time: formatMinutes(start + interval * i),
      };
      slots.push({ ...slot, key: reservationSlotKey(slot) });
    }
  });
  return slots;
};

export const findReservationSlot = (slots, selectedKey) =>
  slots.find((slot) => slot.key === selectedKey);

// Some older API responses omit reservationDayId; fall back to date/time.
export const isReservedSlot = (slot, reservations = []) =>
  reservations.some((reserved) =>
    String(reserved.subTime).slice(0, 5) === slot.time &&
    (reserved.reservationDayId == null || String(reserved.reservationDayId) === String(slot.reservationDayId))
  );

export const findInitialReservationSlot = (slots, time, reservationDayId) =>
  slots.find((slot) => slot.time === String(time || '').slice(0, 5) &&
    (reservationDayId == null || String(slot.reservationDayId) === String(reservationDayId)));
